import { createSelector } from "reselect";

const kkmGroupListSelector = state => state.kkmGroupList;

export const isLoadingSelector = createSelector(kkmGroupListSelector, state => state.isLoading);
export const isNoItemsSelector = createSelector(kkmGroupListSelector, state => state.isNoItems);
export const scrollSelector = createSelector(kkmGroupListSelector, state => state.scroll);
export const itemsSelector = createSelector(kkmGroupListSelector, state => state.items);
